import _ from "lodash";

const assets = {
  bg: "/images/preview/staticmedia.jpg",
};

export default assets;
